import { render, staticRenderFns } from "./ChangeGarmentColorPricing.vue?vue&type=template&id=f8380836&"
import script from "./ChangeGarmentColorPricing.vue?vue&type=script&lang=js&"
export * from "./ChangeGarmentColorPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports